<template>
  <div id="">
    <vxe-grid v-bind="addTableList" @cell-dblclick="dbClick" :row-class-name="rowClassName">
      <template v-slot:toolbar>
        <vxe-toolbar custom>
          <template v-slot:buttons>
            <vxe-form>
              <vxe-form-item title="">
                <template #default>
                  <vxe-select v-model="search_select" :placeholder="$t('message.placeholder.select')">
                    <vxe-optgroup :label="$t('message.table.user')">
                      <vxe-option value="1" :label="$t('message.table.user')"></vxe-option>
                      <!-- <vxe-option value="2" label="用户组"></vxe-option> -->
                    </vxe-optgroup>
                    <!-- <vxe-optgroup :label="$t('message.table.group')">
                      <vxe-option v-for="item in userGroupLists1" :value="item.id" :label="item.name" :key="item.id" :disabled="item.disabled"></vxe-option>
                    </vxe-optgroup> -->
                  </vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <template v-slot>
                  <vxe-input v-model="searchVal" :placeholder="$t('message.placeholder.search')"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <template v-slot>
                  <vxe-button status="primary" @click="searchClick">{{$t('message.button.search')}}</vxe-button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </template>
        </vxe-toolbar>
      </template>
    </vxe-grid>
  </div>
</template>

<style>
   .vxe-table .vxe-body--row.row-disabled {
      background-color: #e9e9eb;
      color: #909399;
    }
</style>

<style scoped>
  
</style>

<script>
  export default {
    name: "searchAdd", //模板名称
    props: ["userGroupLists1", "userGroupLists2", "projectWorkflowSubClassId"],
    data() {
      return {
        privList:[],//无权限列表
        rols_text:"",
        search_select_group: [{
          value: "123",
          label: "123"
        }], //搜索中下拉列表用户组列表
        search_select: "1",
        searchVal: "",
        get_change_info: "",
        rols_text: [],
        tableShow: false,
        oldTableValue: [],
        rols_text: [],
        cols: [],
        addTableList: {
          keepSource: true,
          resizable: true,
          border: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "530",
          size: "small",
          columns: [],
          data: [],
          treeConfig: {
            lazy: true,
            children: 'children',
            hasChild: 'hasChildren',
            loadMethod: this.loadChildrenMethod
          },
          editConfig: {},
          sortConfig: {
            trigger: 'cell'
          },
        },
      }
    },
    mounted() {},
    methods: {
      rowClassName ({ row, rowIndex }) {
        if (this.privList.includes(rowIndex)) {
          return 'row-disabled'
        };
        //console.log(this.privList);
      },
      dbClick(row) {
        //console.log(row.row);
        if(row.row.authTag == 0) {
          this.$message.error(this.$t('message.error.privilegeUser'));
        } else {
          this.$emit('listDbClick', row.row);
        };
      },
      async searchClick() {
        //console.log(this.searchVal);
        let subClassId = this.projectWorkflowSubClassId || "";
        let val = this.searchVal;
        let vm = this;
        let groupId = "";
        let searchType = "";
        //   if(val == '') {
        //     vm.$message({
        //       showClose: true,
        //       message: this.$t('message.warning.searchErr_01'),
        //       type: 'warning'
        //     });
        //   }  else {
        //console.log(this.search_select);
        if (this.search_select == 1) {
          searchType = 1;
        } else {
          searchType = 3;
          groupId = this.search_select;
        };
        const { //获取标题
          data: res
        } = await this.$http.get("/pmdm/admin/user/queryPrivUsers?loginId=" + val + "&privType=16&searchType=" +
          searchType + "&groupId=" + groupId + "&subclassId=" + subClassId);
        console.log(res);
        if (res.code == 200) {
          if (res.object.table.rows.length == 0) {
            vm.$message({
              showClose: true,
              message: this.$t('message.warning.searchErr_02'),
              type: 'warning'
            });
            this.addTableList.data = [];
          } else {
            let title_val = this.getNewTableTitleData(res).slice(0);
            title_val.shift();
            this.addTableList.columns = title_val;
            this.rols_text = this.getNewTableContentData(res);
            this.addTableList.data = this.rols_text;
            //console.log(this.rols_text);
            this.privList = [];
            for(var i = 0; i < this.rols_text.length; i++) {
              console.log(this.rols_text[i].authTag);
              if(this.rols_text[i].authTag == 0) {
                this.privList.push(i);
              }
            };
            //console.log(this.privList);
          }
        };
        //   }
      },
    },
    created() {

    }
  };
</script>